<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 210px">
        <p>委托商：</p>
        <el-input v-model="condition.entrustIpt" size="mini" style="width:150px" placeholder="请输入委托商名称"/>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" class="addBtn" type="primary" @click="addBtn">新增</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableData"
          style="width: 100%"
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}">
          <el-table-column label="序号" align="center" width="50px" type="index"/>
          <el-table-column prop="customerName" label="委托商" align="center"/>
          <el-table-column prop="supplierPortName" label="港口" align="center"/>
          <el-table-column prop="customerCarName" label="适配车型" align="center"/>
          <el-table-column prop="startDate" label="有效起始" align="center"/>
          <el-table-column prop="endDate" label="结束时间" align="center"/>
          <el-table-column label="状态" align="center">
            <div slot-scope="scope">{{getState(scope.row.status)}}</div>
          </el-table-column>
          <el-table-column label="操作" width="270" align="center">
            <template slot-scope="scope">
              <div style="display:flex;align-items:center;padding-left: 10px">
                <!-- <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id)">详情</el-button>
                <el-button size="mini" class="yellow-bg" type="primary" @click="changeClick(scope.row.id)">修改</el-button>
                <el-button size="mini" type="primary" @click="enableClick(scope.row.id)">启用</el-button>
                <el-button size="mini" type="danger" @click="disableClick(scope.row.id)">停用</el-button>
                <el-button size="mini" type="info" @click="deleteClick(scope.row.id)">删除</el-button> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="700" center @close="dialogClose">
      <el-form :model="form" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-row>
          <el-col :span="24">
            <el-form-item label="公司类型：" prop="companyType">
              <el-radio-group v-model="form.companyType">
                <el-radio :label="1">委托商</el-radio>
                <el-radio :label="2">公路供应商</el-radio>
                <el-radio :label="3">水路供应商</el-radio>
                <el-radio :label="4">港口及其他</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="公司名称：" prop="companyName">
              <el-select v-model="form.companyName" style="width:100%" size="small" filterable placeholder="请选择公司名称">
                <el-option label="公司1" value="company1"></el-option>
                <el-option label="公司2" value="company2"></el-option>
                <el-option label="公司3" value="company3"></el-option>
                <el-option label="公司4" value="company4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效期始：" prop="startDate">
              <el-date-picker v-model="form.startDate" filterable style="width:100%" type="date" size="small" placeholder="请选择有效期始"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间：" prop="endDate">
              <el-date-picker v-model="form.endDate" style="width:100%" type="date" size="small" placeholder="请选择结算时间"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="税率：" prop="taxRate">
              <el-input v-model="form.taxRate" size="small" class="tax-style" placeholder="请选输入税率"/><i class="unit">%</i>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="按每" class="billing-style" prop="billing">
              <el-select v-model="form.billing.date" @change="handleDate" style="width:48%;margin-right:4%" size="small" filterable>
                <el-option label="天" :value="'day'"></el-option>
                <el-option label="月" :value="'month'"></el-option>
              </el-select>
              <el-select v-if="form.billing.date=='day'" style="width:48%" size="small" v-model="form.billing.time" filterable>
                <el-option v-for="item in billingDay" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <el-select v-if="form.billing.date=='month'" style="width:48%" size="small" v-model="form.billing.time" filterable>
                <el-option v-for="item in billingMonth" :key="item.value" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          <el-col :span="24">
            <el-form-item label="收入" class="billing-style" prop="price">
              <el-input v-model="form.price" size="small" style="width:calc(100% - 50px);" placeholder="请选输入收入" />
              <span style="display:inline-block;width:50px;text-align:right;">元计费</span>
            </el-form-item>
          </el-col>

          </el-col>
        </el-row>
        <div class="btnContainer">
          <el-button class="searchBtn" type="primary" size="medium" @click="submitForm()">提交</el-button>
          <el-button class="resetBtn" size="medium" @click="resetForm()">重置</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    let checkTaxRate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('税率不能为空'));
      }
      let reg=/^\d\.([1-9]{1,2}|[0-9][1-9])$|^[1-9]\d{0,1}(\.\d{1,2}){0,1}$|^100(\.0{1,2}){0,1}$/;
      console.log(reg.test(value));
      if(!reg.test(value)) {
        return callback('税率应该大于0小于100且最多保留两位小数');
      }
    }
    let checkPrice = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('收入不能为空'));
      }
      let reg = /(^[1-9]([0-9]*)$|^[0-9]$)/;
      if(!reg.test(value)) {
        return callback('收入必须为合法数据');
      }
    }
    return {
      // 查询条件
      condition: {entrustIpt:''},
      // 表格
      TableData: [],  // 表格列表数据
      tableLoad: false,  // 表格加载状态
      total: 0,   // 表格总数居
      size: 10,  // 表格每页数据条数
      page: 1,  // 当前页
      dialogVisible:false,  // 弹窗显影
      dialogTitle: '新增',  // 弹窗表头
      // 新增表单数据
      form: {
        companyType: 1,
        companyName: '',
        startDate: '',
        endDate: '',
        taxRate: '',
        billing: {date:'day',time:''},
        price: '',
      },
      // 新增表单必填验证
      rules: {
        companyType: [{required: true, message: '公司类型不能为空', trigger: 'blur'}],
        companyName: [{required: true, message: '公司名称不能为空', trigger: 'blur'}],
        startDate: [{required: true, message: '有效期始不能为空', trigger: 'blur'}],
        endDate: [{required: true, message: '结束时间不能为空', trigger: 'blur'}],
        taxRate: [{validator: checkTaxRate, trigger: 'blur'}],
        billing: [{required: true, message: '时间单位不能为空', trigger: 'blur'}],
        price: [{validator: checkPrice, trigger: 'blur'}],
      },
      billingDay:['00','01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23'],
      billingMonth:[{name:'月前',value:'1'},{name:'月中',value:'2'},{name:'月末',value:'3'}],
    };
  },
  methods: {
    
    // 查询
    searchBtn(){
      this.page = 1;
      // this._consignorOtherList();
    },
    // 重置
    resetBtn(){
      this.condition.entrustIpt='';
    },
    // 新增
    addBtn(){
      this.dialogVisible = true;
      this.dialogTitle='添加'
      this.companyData={
        transfer:1,
        mention:1,
        discharge:1,
      }
    },
    // 新增/修改 —— 确认
    submitForm() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          console.log(this.form);
        } else {
          this.$message.error('请填写表单数据！');
          return false;
        }
      });
    },
    // 关闭弹窗
    dialogClose() {
      this.dialogVisible = false;
      this.form = {companyType:1,companyName:'',startDate:'',endDate:'',
        taxRate:'',billing:{date:'day',time:''},price:'',};
      this.$refs['ruleForm'].resetFields();
    },
    // 时间单位 —— 改变
    handleDate() {
      this.form.billing.time = '';
    },
    // 每页数据改变
    contractSizeChange(sizes){
      this.size=sizes;
      // this._consignorOtherList();
    },
    // 翻页
    contractCurrentChange(page){
      this.page=page;
      // this._consignorOtherList();
    },
  }
}
</script>

<style lang="scss" scoped>
.mainContainer {
  display: block;
  width: 100%;
  height: calc(100% - 30px);
  padding: 20px 15px 0 25px;
  overflow-y: auto;
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 30px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-badge__content{
          top: 4px !important;
          right: 1px !important;
        }
        .el-badge__content{
          background-color: #F56C6C !important;
        }
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .detail{
    width: 100%;
    padding: 10px 0 20px 20px;
    max-height:70vh;
    overflow: auto;
    .baseInfo{
      display: flex;
      flex-direction: column;
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        .addressItem{
          font-size: 12px;
          color: rgba(153, 153, 153, 1);
          margin-bottom: 10px;
          margin-left: 70px;
        }
        &Item{
          margin-bottom: 20px;
          .imgContainer{
            display:flex;
            align-items: center;
          }
          .span1{
            font-weight: 700;
          }
          span{
            font-size: 14px;
          }
          .specialOne{
            width:50%;
          }
        }
        .specialItem{
          display:flex;
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      ::v-deep{
        .el-table td, .el-table th{
          padding:0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;
      }
    }
  }
  .reasonContainer{
    width:100%;
    padding: 20px 30px;
    ::v-deep{
      .el-textarea__inner{
        min-height: 100px!important;
      }
    }
    .reasonBtn{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content:flex-end;
    }
  }
  .carContainer{
    width:100%;
    padding: 15px 40px 10px 20px;
    max-height:75vh;
    overflow:auto;
    &Title{
      display: flex;
      flex-direction: column;
      span{
        color: #101010;
        font-weight: 700;
        margin-bottom: 5px;
      }
      &Content{
        width:100%;
        padding-left: 15px;
        display: flex;
        flex-wrap: wrap;
        align-items:center;
        margin-bottom: 10px;
        &Item{
          height:25px;
          padding:0 5px;
          background-color: #a4adb3;
          color:#fff;
          display: flex;
          align-items:center;
          justify-content:space-between;
          margin-right: 10px;
          margin-bottom: 5px;
          i{
            color:#000;
            font-size: 17px;
            cursor: pointer;
          }
          p{
            cursor: pointer;
          }
        }
      }
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;
      button{
        margin: 0 15px;
      }
    }
  }
  .depart{
    width:100%;
    padding: 10px 40px 10px 10px;
    max-height:75vh;
    overflow:auto;
    .specialItem{
      ::v-deep {
        .el-form-item__content{
          margin-left: 0!important;
        }
      }
    }
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-form-item{
        margin-bottom:13px;
      }
      .el-form-item__label{
        padding:0;
      }
      .el-form-item__content{
        position: relative;
      }
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;
      button{
        margin: 0 15px;
      }
    }
  }
  ::v-deep{
    .el-table th>.cell{
      font-weight: 700!important;
    }
  }
  .unit {
    display: inline-block;
    position: absolute;
    color: #dcdfe6;
    width: 30px;
    height: 32px;
    text-align: center;
    top: 5px;
    line-height: 32px;
    right: 0px;
    border-left: 1px solid #dcdfe6;
  }
  .btnContainer {
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  .searchBtn {
    background-color: #335483 !important;
    color: #fff !important;
    border: none !important;
  }
  .addBtn {
    height: 30px;
    width: 54px;
  }
}
::v-deep {
  form.el-form.demo-ruleForm {
    position: relative;
    width: 650px;
    margin: 0 auto;
  }
  .el-row {
    padding: 30px 20px 10px;
    margin-bottom: 20px;
    border: 1px solid #c3c3c3;
  }
  .el-form-item__label {
    padding: 0px;
  }
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }
  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }
  .el-dialog__headerbtn {
    position: absolute;
    top: 9px;
    right: 20px;
    padding: 0;
    background: 0 0;
    border: none;
    outline: 0;
    cursor: pointer;
  }
  i.el-dialog__close.el-icon.el-icon-close {
    color: #fff;
    font-size: 25px;
  }
  .tax-style input.el-input__inner {
    padding-right: 40px;
  }
  .billing-style label.el-form-item__label {
    padding-right: 10px;
  }
  .el-dialog--center .el-dialog__body {
    overflow-y: auto;
    max-height: 70vh;
    width: 700px;
  }
  .el-dialog.el-dialog--center {
    width: 700px;
  }
}
</style>
